/*=========================================================================================
  File Name: main.js
  Description: main vue(js) file
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

// @ts-nocheck

import 'url-polyfill'

import Vue from 'vue'
import App from './App.vue'

import axios from 'axios'

import {
  firebase,
  auth
} from './firebase/firebaseConfig.js'

// Vuesax Component Framework
import Vuesax from 'vuesax'
import 'material-icons/iconfont/material-icons.css' //Material Icons
import 'vuesax/dist/vuesax.css' // Vuesax
Vue.use(Vuesax)

// axios
import axios from './axios.js'
Vue.prototype.$http = axios

// API Calls
import './http/requests'

// mock
import './fake-db/index.js'

// Theme Configurations
import '../themeConfig.js'


// Firebase
import '@/firebase/firebaseConfig'


// Auth0 Plugin
import AuthPlugin from './plugins/auth'
Vue.use(AuthPlugin)

// ACL //removed in Jan '22 (new commit)
//import acl from './acl/acl'


// Globally Registered Components
import './globalComponents.js'


// Styles: SCSS
import './assets/scss/main.scss'


// Tailwind
import '@/assets/css/main.css'


// Vue Router
import router from './router'


// Vuex Store
import store from './store/store'


// i18n
import i18n from './i18n/i18n'


// Vuexy Admin Filters
import './filters/filters'


// Clipboard
import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)


// Tour
//import VueTour from 'vue-tour'
//Vue.use(VueTour)
//require('vue-tour/dist/vue-tour.css')


// VeeValidate
import VeeValidate from 'vee-validate'
Vue.use(VeeValidate)


// Google Maps
import * as VueGoogleMaps from 'vue2-google-maps'
Vue.use(VueGoogleMaps, {
  load: {
    // Add your API key here
    key: 'YOUR_KEY',
    libraries: 'places' // This is required if you use the Auto complete plug-in
  }
})

// Vuejs - Vue wrapper for hammerjs - special mobile functionality
import { VueHammer } from 'vue2-hammer'
Vue.use(VueHammer)


// PrismJS
import 'prismjs'
import 'prismjs/themes/prism-tomorrow.css'


// Feather font icon
require('./assets/css/iconfont.css')

Vue.mixin({
  methods: {
    validateEmail(email) {
      return Boolean(email.match(
        /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      ))
    },
    chatToUs() {
      (<any>window).Beacon('open')
    },
    fallbackCopyTextToClipboard(text) {
      const textArea = document.createElement('textarea')
      textArea.value = text

      // Avoid scrolling to bottom
      textArea.style.top = '0'
      textArea.style.left = '0'
      textArea.style.position = 'fixed'

      document.body.appendChild(textArea)
      textArea.focus()
      textArea.select()

      try {
        const successful = document.execCommand('copy')
        const msg = successful ? 'successful' : 'unsuccessful'
        //noconsoleconsole.log(`Fallback: Copying text command was ${  msg}`)
      } catch (err) {
        console.error('Fallback: Oops, unable to copy', err)
      }

      document.body.removeChild(textArea)
    },
    copyTextToClipboard(text) {
      if (!navigator.clipboard) {

        //TS, removing warning by changing the this to any, becuase typescript think it's of type Vue
        (<any>this).fallbackCopyTextToClipboard(text)
        return
      }
      navigator.clipboard.writeText(text).then(function () {
        //noconsoleconsole.log('Copied text')
      }, function (err) {
        console.error('Async: Could not copy text: ', err)
      })
    },
    getRandomChars() {
      return (Math.floor(Math.random() * (11 - 5 + 1)) + 5)
    },
    shortDateFromString(myDate) {
      myDate = myDate.split('-')
      //dd mm yyyy
      //yyyy mm dd

      //TS: removing warning by changing the this to any, becuase typescript think it's of type Vue
      return (<any>this).shortDate(new Date(myDate[0], myDate[1] - 1, myDate[2]).getTime() / 1000)
    },
    shortDate(timestamp) {
      const unix_timestamp = timestamp
      // Create a new JavaScript Date object based on the timestamp
      // multiplied by 1000 so that the argument is in milliseconds, not seconds.
      const date = new Date(unix_timestamp * 1000)

      const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
      const year = date.getFullYear()
      const month = months[date.getMonth()]
      const dateString = date.getDate()

      // Hours part from the timestamp
      const hours = date.getHours()
      // Minutes part from the timestamp
      const minutes = `0${date.getMinutes()}`
      // Seconds part from the timestamp
      const seconds = `0${date.getSeconds()}`
      // Will display time in 10:30:23 format
      return String(`${dateString} ${month} '${String(year).substr(2, 2)}`)
    },
    formatTimeStamp(timestamp) {
      const unix_timestamp = timestamp
      // Create a new JavaScript Date object based on the timestamp
      // multiplied by 1000 so that the argument is in milliseconds, not seconds.
      const date = new Date(unix_timestamp * 1000)

      const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
      const year = date.getFullYear()
      const month = months[date.getMonth()]
      const dateString = date.getDate()

      // Hours part from the timestamp
      const hours = date.getHours()
      // Minutes part from the timestamp
      const minutes = `0${date.getMinutes()}`
      // Seconds part from the timestamp
      const seconds = `0${date.getSeconds()}`
      // Will display time in 10:30:23 format
      return String(`${dateString} ${month} ${year} ${hours}:${minutes.substr(-2)}:${seconds.substr(-2)}`)
    },
    genRandomUID(uid) {
      let textBefore = ''
      let textAfter = ''
      const possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
      const charsBefore = (<any>this).getRandomChars()
      const charsAfter = (<any>this).getRandomChars()
      for (let i = 0; i < charsBefore; i++) {
        textBefore += possible.charAt(Math.floor(Math.random() * possible.length))
      }
      for (let j = 0; j < charsAfter; j++) {
        textAfter += possible.charAt(Math.floor(Math.random() * possible.length))
      }
      //noconsoleconsole.log(`before:${  textBefore}`)
      //noconsoleconsole.log(`after:${  textAfter}`)
      return (textBefore + uid + textAfter)
    },
    urlify(v) {
      return v.toLowerCase().replace(/ /g, '').replace(/[^\w-]+/g, '')
    },
    validateEmail(email) {
      const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return re.test(String(email).toLowerCase())
    },
    scrollToBottom() {
      window.scrollTo({
        top: document.body.scrollHeight,
        left: 0,
        behavior: 'smooth'
      })
    },
    scrollToTop() {
      window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
    },
    validURL(str) {
      const pattern = new RegExp(//'^(https?:\\/\\/)?'+ // protocol
        '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
        '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
        '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
        '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
        '(\\#[-a-z\\d_]*)?$', 'i') // fragment locator
      return !!pattern.test(str)
    }
  }
})

// Vue select css
// Note: In latest version you have to add it separately
// import 'vue-select/dist/vue-select.css';


Vue.config.productionTip = false

let vm

Vue.config.productionTip = false



const init = (brandData = false) => {

  if (brandData) {    
    store.commit('dash/CHANGE_BRAND', {
      brandHex: brandData.brandHex,
      brandLogo: brandData.logoURL
    })
  }

  auth.onIdTokenChanged(function (user) {

    //noconsoleconsole.log('AUTH HAS LOADED/CHANGED')

    if (user) {
      //noconsoleconsole.log('hasuser')
    } else if (vm) {
      store.commit('auth/SIGNOUT')
      router.push('/dash/login')
    }

    if (!vm) {
      //noconsoleconsole.log('no VM')
      vm = new Vue({
        router,
        el: '#app',
        store,
        i18n,
        //acl, //we not using acl, removed in Jan '22 (new commit)
        render: h => h(App)
      })
    }

  })


}

const checkOriginInit = () => {

  //if (window.location.href.indexOf('localhost') !== -1) {
    if (window.location.href.indexOf('feedbackevaluate') !== -1) {

    let url

    if (process.env.NODE_ENV === 'development') {
      url = 'http://localhost:1000/api/dash/getbrandinfo'
    } else {
      url = 'https://dashboard-ymms4zbska-uc.a.run.app/api/dash/getbrandinfo'
    }

    //fetch branding details from open API
    const details = axios.post(url, {
      href: window.location.href
    }, {
      headers: {
        'Content-Type': 'application/json',
      }
    }).then((res) => {
      document.getElementById('pt_loading_spinner').style.borderTopColor =res.data.brandHex;
      init(res.data)
    }).catch((e) => {
      document.getElementById('pt_loading_spinner').style.borderTopColor = '#000000';
      init({
        brandHex: '#000000',
        logoURL: 'https://firebasestorage.googleapis.com/v0/b/feedbacklink-fbl.appspot.com/o/customerresponses.png?alt=media&token=2f8203d1-da1c-451e-9d8e-5b9e4e2a66fb'
      })
    })

  } else {

    document.title = 'Feedback Link | Dashboard'
    init()

  }
}

checkOriginInit()



